export default "__VITE_ASSET__Jxyx24uG__"